<template>
  <div class="opc-zone-bundle__main">
    <zm-form>
      <!--How many numbers do you need.-->
      <zm-form-item>
        <!--Total numbers Row-->
        <div
          :class="{ 'opc-pbx-number-item__combine': !localSplitStyle, 'opc-pbx-number-item__split': localSplitStyle }"
          class="opc-pbx-number-item opc-pbx-number-item__total"
        >
          <div class="opc-pbx-number-item__title-wrap">
            <p class="label-title-1">
              {{ $t('billing.zone_pro_plus.select_local_number_title') }}
              <zm-tooltip
                v-model="attendeeInfoTooltip"
                slot="label-suffix"
                aria-label="Learn more about numbers"
                placement="top"
              >
                <zm-button data-testid="checkout-button-110" ghost icon="zm-icon-info-outline main-color-icon" size="mini" type="icon"></zm-button>
                <template v-slot:content>
                  {{ $t('billing.zone.attendee_info', [attendee]) }}
                  <zm-button data-testid="checkout-button-111" v-if="showLmPromo" @click="addLargeMeetingCard" class="opc-pbx-number-item__tip-lm-btn" type="link">{{$t('billing.large_meeting.increase_with')}}</zm-button>
                </template>
              </zm-tooltip>
            </p>
            <template>
              <p v-if="!showTryOtherPlans" class="label-desc-1">
                <span>{{ $t('billing.zone_pro_plus.select_local_number_desc') }}</span>
                <zm-button data-testid="checkout-button-112" style="margin-left: 3px" type="link" @click="handleExploreOtherPlans">
                  {{ $t('billing.zone_pro_plus.explore_other_plans_cta') }}
                </zm-button>
              </p>
              <zm-alert v-else class="opc-pbx-number-item__max-limit" type="warning" :closable="false">
                <div class="opc-pbx-number-tips-info">
                  <i class="billing-icon-warning" />
                  <div class="opc-pbx-number-tips-info__content">
                    <p>{{ $t('billing.zone_pro_plus.max_user_tips', [maxPurchaseLicense]) }}</p>
                    <zm-button data-testid="checkout-button-113" type="link" @click="handleExploreOtherPlans">
                      {{ $t('billing.zone_pro_plus.explore_other_plans_cta') }}
                    </zm-button>
                  </div>
                </div>
              </zm-alert>
            </template>
          </div>
          <InputNumberWithPopover
            v-if="!localSplitStyle"
            v-model="form.localNumber"
            :max="localMax"
            :min="localMinObj.count"
            :decrease-tips="localMinObj.tips"
            :label="`${trackingPlanName} Select the ${$t('billing.pbx.local_numbers')} of users`"
            controls-position="both"
            size="large"
            @change="handleLocalNumberChange"
          />
        </div>

        <!--Error Message row-->
        <zm-alert
          v-if="phoneNumberTips"
          class="opc-pbx-number-item opc-pbx-number-alert-wrap"
          :type="phoneNumberTips.type"
        >
          <div class="opc-pbx-number-tips-info">
            <i class="zm-icon-info-outline" v-if="phoneNumberTips.type === 'info'" />
            <i class="billing-icon-warning" v-if="phoneNumberTips.type === 'warning'" />
            <p v-html="phoneNumberTips.text"></p>
          </div>
        </zm-alert>

        <!--local row-->
        <div class="opc-pbx-number-item opc-pbx-number-item__local">
          <!--local numbers-->
          <div v-if="localSplitStyle" class="form-row">
            <p class="label-title-2">{{ $t('billing.pbx.local_numbers') }}</p>
            <InputNumberWithPopover
              v-model="form.localNumber"
              :label="`${trackingPlanName} Select the ${$t('billing.pbx.local_numbers')} of users`"
              :max="localMax"
              :min="localMinObj.count"
              :decrease-tips="localMinObj.tips"
              controls-position="both"
              size="large"
              @change="handleLocalNumberChange"
            />
          </div>
          <!--local number list row-->
          <div v-if="showLocalNumberRowItem" class="form-row">
            <div role="group">
              <zm-tag
                v-for="(numberItem, idx) in localNumberState.pickedNumberList"
                :key="numberItem.label"
                :closable="localNumberState.pickedNumberList.length > localMinObj.count"
                class="number-tag"
                @close="onRemoveNumber(phoneNumberTypeMap.local, idx)"
                :delete-text="getDeletePhoneNumberAriaLabel(numberItem.displayName)"
              >
                {{ numberItem.displayName }}
              </zm-tag>
            </div>
          </div>
          <!--local number operation row-->
          <div v-if="localOperationConfig" class="form-row">
            <zm-button
              v-if="localOperationConfig.type !== buttonTypeMap.loading"
              data-testid="checkout-button-114"
              :round="localOperationConfig.round"
              :type="localOperationConfig.type"
              class="edit-numbers"
              @click="localOperationConfig.onClick"
            >
              {{ localOperationConfig.text }}
            </zm-button>
            <div v-else v-loading="true" class="operation-loading" spinner="operation-loading-icon"></div>
          </div>
        </div>
        <!--toll-free row-->
        <div v-if="form.tollFreeNumber" class="opc-pbx-number-item opc-pbx-number-item__tf">
          <!--toll-free numbers-->
          <div class="form-row">
            <div>
              <p class="label-title-2">{{ $t('billing.pbx.toll_free_numbers') }}</p>
              <p v-if="tfPriceLineText" class="label-title-sub">{{ tfPriceLineText }}</p>
            </div>
            <InputNumberWithPopover
              v-model="form.tollFreeNumber"
              :label="`${trackingPlanName} Select the ${$t('billing.pbx.toll_free_numbers')} of users`"
              :max="tollFreeMax"
              controls-position="both"
              size="large"
              @change="handleTollFreeNumberChange"
            />
          </div>
          <!--toll-free number list-->
          <div v-if="showNumberList && tollFreeNumberState.pickedNumberList.length" class="form-row">
            <div role="group">
              <zm-tag
                v-for="(numberItem, idx) in tollFreeNumberState.pickedNumberList"
                :key="numberItem.label"
                class="number-tag"
                closable
                @close="onRemoveNumber(phoneNumberTypeMap.tollFree, idx)"
                :delete-text="getDeletePhoneNumberAriaLabel(numberItem.displayName)"
              >
                {{ numberItem.displayName }}
              </zm-tag>
            </div>
          </div>
          <!--toll-free operation row-->
          <div v-if="tollFreeOperationConfig" class="form-row">
            <zm-button
              v-if="tollFreeOperationConfig.type !== 'loading'"
              data-testid="checkout-button-115"
              :round="tollFreeOperationConfig.round"
              :type="tollFreeOperationConfig.type"
              class="edit-numbers"
              @click="tollFreeOperationConfig.onClick"
            >
              {{ tollFreeOperationConfig.text }}
            </zm-button>
            <div v-else v-loading="true" class="operation-loading" spinner="operation-loading-icon"></div>
          </div>
        </div>
        <!--porting your number row-->
        <div class="opc-pbx-number-item opc-pbx-number-item__port">
          <!--porting numbers-->
          <div v-if="portNumberList.length" class="form-row">
            <p class="label-title-2">{{ $t('billing.pbx.ready_for_porting') }}</p>
            <InputNumberWithPopover
              ref="portNumberInput"
              :max="portMax"
              :min="portMinObj.count"
              :decrease-tips="portMinObj.tips"
              :value="portNumberList.length"
              controls-position="both"
              label="Ready for porting number"
              size="large"
              @input="handlePortNumberInput"
            />
          </div>
          <!--porting number list-->
          <div v-if="portNumberList.length" class="form-row">
            <div role="group">
              <zm-tag
                v-for="(numberItem, idx) in portNumberList"
                :key="numberItem"
                :closable="portNumberList.length > portMinObj.count"
                class="number-tag"
                @close="onRemovePortNumberList(idx)"
                :delete-text="getDeletePhoneNumberAriaLabel(numberItem, true)"
              >
                {{ numberItem | phoneFormat }}
              </zm-tag>
            </div>
          </div>
          <!--porting operations-->
          <div class="form-row">
            <p v-if="!portNumberList.length">
              {{ $t('billing.pbx.have_existing_number') }}
              <zm-button data-testid="checkout-button-116" class="opc-pbx__link" type="link" @click="handlePortNumbers('Validate numbers for porting')">
                {{ $t('billing.pbx.valid_for_porting') }}
              </zm-button>
            </p>
            <p v-else>
              {{ $t('billing.pbx.port_number_desc') }}
              <zm-button
                data-testid="checkout-button-117"
                class="opc-pbx__link"
                type="link"
                @click="handlePortNumbers('Validate more numbers for porting')"
              >
                {{ $t('billing.pbx.valid_more_porting') }}
              </zm-button>
            </p>
          </div>
        </div>
        <!-- config billing cycle -->
        <plan-billing-cycle
          v-model="pbxBillingCycle"
          :category-list="planList"
          class="opc-zone-cycle"
          @updatePbxBasePlanCode="updatePbxBasePlanCode"
        />
        <!-- config pbx base plan -->
        <config-pbx-base v-model="pbxBasePlanCode" :billing-cycle="pbxBillingCycle" />

      </zm-form-item>
    </zm-form>
    <div v-if="showLmPromo" class="opc-zone-bundle__expand-lm-promo">
      <span>
        {{$t('billing.large_meeting.promo', [attendee])}}
      </span>
      <zm-button data-testid="checkout-button-118" @click="addLargeMeetingCard" type="link">{{$t('billing.large_meeting.increase_with')}}</zm-button>
    </div>
    <div class="opc-zm-base-card__main__footer" v-if="isShowRemoveBtn">
      <zm-button data-testid="checkout-button-119" type="link" ghost @click="removeAllPlans">{{ $t('billing.common.remove') }}</zm-button>
    </div>
  </div>
</template>

<script type="text/jsx">
import _ from 'lodash';
import { localNumberStore, phoneNumberStorage, tollFreeNumberStore } from '@/plans/ZOOM_PHONE/store';
import { getCategoryNameForPbx } from '@/plans/ZOOM_ONE_BUNDLE/utils';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import SelectPhoneNumberDialog from '@/plans/ZOOM_PHONE/component/dialog/phone-number-select';
import ValidatePortNumberDialog from '@/plans/ZOOM_PHONE/component/dialog/port-number-validate';
import { BILLING_CYCLE, planTypes, trackingPlanTypes } from '@/common/constants';
import { PBX_REGIONS, phoneNumberTypeMap } from '@/plans/ZOOM_PHONE/helper/constants';
import { PBX_SUB_TYPES, computedPbxPlans} from '@/common/service/computers/plans/pbx';
import { plansof } from '@/utils/chain';
import { isEmptyVal } from '@/utils';
import phoneNumberApi from '@/plans/ZOOM_PHONE/mixin/phone-number-api';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { logger } from '@/utils/log';
import { getZPCallingFeesText, parsePortNumber } from '@/plans/ZOOM_PHONE/helper/utils';
import InputNumberWithPopover from '@/components/input-number/input-number-with-popover';
import ConfigPbxBase from '@/plans/ZONE_PRO_PLUS/component/pbx-base';
import PbxMixin from '@/plans/ZONE_PRO_PLUS/mixin/pbx-mixin';
import LimitMixin from '@/plans/ZONE_PRO_PLUS/mixin/limit-mixin';
import PlanBillingCycle from '@/plans/ZONE_PRO_PLUS/component/plan-billing-cycle';
import { getPbxContactSalesLink } from '@/utils/i18n-shortcuts';
import { isFromShoppingCart, isProductCanRemove } from '@/views/config/shopping-cart/persist/plan-remove';

const maxPurchaseLicense = 99;
const maxPhoneNumber = 10;

const buttonTypeMap = {
  loading: 'loading',
  link: 'link',
  primary: 'primary',
};

export default {
  components: { PlanBillingCycle, ConfigPbxBase, InputNumberWithPopover },
  inject: ['$core'],
  mixins: [phoneNumberApi, PbxMixin, LimitMixin],
  props: {
    showFullComparisonDialog: {
      type: Function,
      default: _.noop,
    },
    showExploreCTA: Boolean,
    showLmPromo: Boolean,
  },
  filters: {
    phoneFormat: parsePortNumber,
  },
  data() {
    return {
      title: this.$t('billing.zone_pro_plus.title'),
      portNumberList: [],
      numberListLoading: true,
      localNumberState: localNumberStore.state,
      tollFreeNumberState: tollFreeNumberStore.state,
      form: {
        category: '',
        localNumber: 0,
        tollFreeNumber: 0,
        numberList: []
      },
      phoneNumberTypeMap: Object.freeze(phoneNumberTypeMap),
      buttonTypeMap: Object.freeze(buttonTypeMap),
      BILLING_CYCLE: Object.freeze(BILLING_CYCLE),
      maxPurchaseLicense,
      pbxContactSalesLink: getPbxContactSalesLink(),
      attendeeInfoTooltip: false
    };
  },
  computed: {
    ...mapGetters([
      'planMapFlat',
      'getSelectedPlans',
      'getUserCurrentSubscriptions',
      'limitLicenseWithCurrentBaseTypes',
      'pbxBaseInfo'
    ]),
    pbxBillingCycle: {
      get() {
        return this.pbxBaseInfo.billingCycle;
      },
      set(newValue) {
        this.setPbxBillingCycle(newValue);
      }
    },
    pbxBasePlanCode: {
      get() {
        return this.pbxBaseInfo.basePlanCode;
      },
      set(newValue) {
        this.setPbxBasePlanCode(newValue);
      }
    },
    phoneNumberTips() {
      if (this.totalPhoneNumbers >= maxPurchaseLicense) {
        return null;
      }

      if (!this.localNumberState.phoneNumberList.length && this.localNumberState.searchTimes > 0) {
        return {
          text: this.$t('billing.pbx.number_tips_1'),
          type: 'info',
        };
      } else if (!this.showNumberList) {
        return {
          type: 'info',
          text: this.$t('billing.pbx.number_tips_2'),
        }
      }

      return null;
    },
    showTryOtherPlans() {
      return this.totalPhoneNumbers >= maxPurchaseLicense;
    },
    planList() {
      return plansof(this.planMapFlat).type(planTypes.ZONE_PRO_PLUS).region(PBX_REGIONS.US_AND_CANADA).plans;
    },
    totalPhoneNumbers() {
      return this.form.localNumber + this.form.tollFreeNumber + this.portNumberList.length;
    },
    showNumberList() {
      if (this.portNumberList.length >= maxPhoneNumber) {
        return false;
      }
      return this.totalPhoneNumbers <= maxPhoneNumber;
    },
    /** local number button action **/
    localSplitStyle() {
      return (
        this.portNumberList.length ||
        this.form.tollFreeNumber ||
        (!this.tollFreeNumberState.phoneNumberList.length && this.tollFreeNumberState.searchTimes > 0)
      );
    },
    localMinObj() {
      return {
        count: this.portNumberList.length > 0 ? 0 : 1,
        tips: ''
      };
    },
    localMax() {
      return maxPurchaseLicense - (this.totalPhoneNumbers - this.form.localNumber);
    },
    showLocalNumberRowItem() {
      return this.showNumberList && this.localNumberState.pickedNumberList.length;
    },
    showLocalNumberSelectButton() {
      return this.showNumberList && (!this.localNumberState.phoneNumberList.length && this.localNumberState.searchTimes <= 0);
    },
    showLocalNumberEditButton() {
      return (this.localNumberState.phoneNumberList.length || this.localNumberState?.pickedNumberList.length) && this.showNumberList;
    },
    localOperationConfig() {
      if (this.numberListLoading) {
        return {
          type: buttonTypeMap.loading,
        };
      } else if (this.showLocalNumberSelectButton) {
        return {
          type: buttonTypeMap.primary,
          onClick: () => this.handleEditNumbers('local'),
          text: this.$t('billing.pbx.select_your_numbers'),
          round: true,
        };
      } else if (this.showLocalNumberEditButton) {
        return {
          type: buttonTypeMap.link,
          onClick: () => this.handleEditNumbers('local'),
          text: this.$t('billing.pbx.edit_numbers'),
          round: false,
        };
      }

      return null;
    },
    /** tollfree number button action **/
    tollFreeMax() {
      return maxPurchaseLicense - (this.totalPhoneNumbers - this.form.tollFreeNumber);
    },
    showTollFreeNumberSelectButton() {
      return this.showNumberList && (!this.tollFreeNumberState.phoneNumberList.length && this.tollFreeNumberState.searchTimes <= 0);
    },
    showTollFreeNumberEditButton() {
      return (this.tollFreeNumberState.phoneNumberList.length || this.tollFreeNumberState?.pickedNumberList.length) && this.showNumberList;
    },
    tollFreeOperationConfig() {
      if (this.numberListLoading) {
        return {
          type: buttonTypeMap.loading,
        };
      } else if (this.showTollFreeNumberSelectButton) {
        return {
          type: buttonTypeMap.primary,
          onClick: () => this.handleEditNumbers(phoneNumberTypeMap.local),
          text: this.$t('billing.pbx.select_your_numbers'),
          round: true,
        };
      } else if (this.showTollFreeNumberEditButton) {
        return {
          type: buttonTypeMap.link,
          onClick: () => this.handleEditNumbers(phoneNumberTypeMap.tollFree),
          text: this.$t('billing.pbx.edit_numbers'),
          round: false,
        };
      }
      return null;
    },
    defaultTFPlan() {
      if (this.selectedTFPlan) {
        return this.selectedTFPlan;
      }

      return _.find(this.allPbxPlans, item => (
        item.region === PBX_REGIONS.US_AND_CANADA &&
        item.billing_cycle === this.pbxBillingCycle &&
        item.sub_type === PBX_SUB_TYPES.TOLLFREE
      ));
    },
    tfPriceLineText() {
      const defaultTFPlan = this.defaultTFPlan;

      if (defaultTFPlan) {
        const unit = this.$t(`billing.common.per_billing_cycle.${defaultTFPlan.billing_cycle}`);
        const price = defaultTFPlan.amount * defaultTFPlan.cartInfo.selected_number;
        return this.$t('billing.pbx.tf_pricing_line', [`${this.$money(price)}${unit}`]);
      }

      return '';
    },
    /** port number  **/
    portMinObj() {
      return {
        count: this.form.localNumber > 0 ? 0 : 1,
        tips: ''
      }
    },
    portMax() {
      const maxLen = maxPurchaseLicense - (this.totalPhoneNumbers - this.portNumberList.length);
      return Math.min(maxLen, maxPhoneNumber);
    },
    trackingPlanName() {
      return trackingPlanTypes.ZONE_PRO_PLUS;
    },
    isShowRemoveBtn () {
      // For zoom phone can buy independently, just think about zoom workplace pro plus dependency
      if(isFromShoppingCart()) {
        const plan = plansof(this.getSelectedPlans).type(planTypes.ZONE_PRO_PLUS).plans;
        return isProductCanRemove(plan?.[0])
      }
      return false;
    },
    attendee() {
      return 100
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan', 'removePlan', 'setPbxBillingCycle', 'setPbxBasePlanCode', 'batchRemovePlan']),
    ...mapActions(['switchBillingCycleAction', 'switchSelectPlanAction', 'removePlanByKey']),
    getCallingFeesText: getZPCallingFeesText,
    getCategoryName: getCategoryNameForPbx,
    getDeletePhoneNumberAriaLabel(number, shouldFormat = false) {
      const removeTxt = this.$t('billing.common.remove');
      const displayName = shouldFormat ? parsePortNumber(number) : number;
      return `${removeTxt} ${displayName}`;
    },
    handleExploreOtherPlans() {
        this.$tracking.buyInteraction('explore other plans', 'zoom workplace pro plus - explore other plans');
        return this.showFullComparisonDialog();
    },
    /** phone number cache **/
    storagePhoneNumber() {
      phoneNumberStorage.store({
        localNumberState: this.localNumberState,
        tollFreeNumberState: this.tollFreeNumberState,
        portNumberList: this.portNumberList,
      });
    },
    /** local number **/
    updateCallingPlan(localNumber, portNumber) {
      const totalQuantity = localNumber + portNumber;

      if (this.selectedZoneProPlusCallingPlan && totalQuantity > 0) {
        this.updateSelectPlan({
          plan_code: this.selectedZoneProPlusCallingPlan.plan_code,
          cartInfo: { selected_number: totalQuantity },
        });
      }
    },
    handleLocalNumberChange(localLicenses, oldLocalLicenses) {
      this.updateCallingPlan(localLicenses, this.portNumberList.length);
      // picked local number count
      const localNumberCount = this.localNumberState.pickedNumberList.length;
      if (this.totalPhoneNumbers <= maxPhoneNumber && localLicenses > localNumberCount) {
        this.populateNumber(phoneNumberTypeMap.local, localLicenses - localNumberCount);
      } else if (localNumberCount > localLicenses) {
        this.removeNumber(phoneNumberTypeMap.local, localLicenses);
      }
      const opType = localLicenses > oldLocalLicenses ? 'increase' : 'decrease';
      this.$tracking.buyInteraction('number of users', `zoom workplace pro plus - ${opType} - ${localLicenses}`);
    },
    onRemoveNumber(type, idx) {
      let phoneNumberState = this.localNumberState;
      if (type === phoneNumberTypeMap.tollFree) {
        phoneNumberState = this.tollFreeNumberState;
      }
      phoneNumberState.pickedNumberList = phoneNumberState.pickedNumberList.filter((_, i) => idx !== i);
      if (type === phoneNumberTypeMap.local) {
        this.form.localNumber--;
        this.updateCallingPlan(this.form.localNumber, this.portNumberList.length);
      } else {
        this.form.tollFreeNumber--;
        this.updateTFPlan(this.form.tollFreeNumber);
      }
      this.storagePhoneNumber();
    },
    /** sync choose phone numbers to shopping cart **/
    async syncNumberListToCart(res) {
      const checkedPhoneNumberList = _.values(res.checkedPhoneNumberMap);

      this.localNumberState.pickedNumberList = checkedPhoneNumberList.filter(item => item.type === phoneNumberTypeMap.local);
      this.tollFreeNumberState.pickedNumberList = checkedPhoneNumberList.filter(item => item.type === phoneNumberTypeMap.tollFree);

      if (this.localNumberState.phoneNumberList.length && this.localNumberState.pickedNumberList.length) {
        this.form.localNumber = this.localNumberState.pickedNumberList.length;
      }

      if (this.tollFreeNumberState.phoneNumberList.length) {
        this.form.tollFreeNumber = this.tollFreeNumberState.pickedNumberList.length;
      }

      this.updateCallingPlan(this.form.localNumber, this.portNumberList.length);
      this.updateTFPlan(this.form.tollFreeNumber);
      this.storagePhoneNumber();
    },
    handleEditNumbers(type) {
      this.$tracking.buyInteraction(this.trackingPlanName, `${this.getCategoryName(this.form.category)} - edit numbers`);

      const checkedPhoneNumberMap = [
        ...this.localNumberState.pickedNumberList,
        ...this.tollFreeNumberState.pickedNumberList,
      ].reduce((pre, item) => ({
        ...pre,
        [item.label]: item,
      }), {});

      this.selectPhoneNumberDialog.confirm({
        clearable: !this.localMinObj.count,
        checkedPhoneNumberMap,
        searchByPhoneType: type,
        localCount: this.form.localNumber,
        tollFreeCount: this.form.tollFreeNumber,
        portCount: this.portNumberList.length,
        maxSelectPhoneNumbers: maxPhoneNumber,
      }).then((res) => {
        this.syncNumberListToCart(res);
      })
    },
    populateNumber(type, numberCount) {
      let phoneNumberState = this.localNumberState;
      if (type === phoneNumberTypeMap.tollFree) {
        phoneNumberState = this.tollFreeNumberState;
      }
      const res = Array.from({ length: numberCount }, () => {
        const nextNumber = phoneNumberState.cachePhoneNumberList
          .find(item => !phoneNumberState.pickedNumberList.find(item2 => item2.label === item.label));
        nextNumber && phoneNumberState.pickedNumberList.push(nextNumber);
        return nextNumber;
      }).filter(Boolean);

      this.storagePhoneNumber();
      return res;
    },
    removeNumber(type, value) {
      let phoneNumberState = this.localNumberState, arr = [];
      if (type === phoneNumberTypeMap.tollFree) {
        phoneNumberState = this.tollFreeNumberState;
      }
      arr = [...phoneNumberState.pickedNumberList];
      arr = arr.slice(0, value);
      phoneNumberState.pickedNumberList = arr;
      this.storagePhoneNumber();
    },
    updateTFPlan(tollFreeNumber) {
      this.defaultTFPlan && this.updateSelectPlan({
        plan_code: this.defaultTFPlan.plan_code,
        cartInfo: { selected_number: tollFreeNumber },
      });
    },
    handleTollFreeNumberChange(value, oldValue) {
      this.updateTFPlan(value);
      const numberListLen = this.tollFreeNumberState.pickedNumberList.length;
      if (this.totalPhoneNumbers <= maxPhoneNumber && numberListLen < value) {
        this.populateNumber(phoneNumberTypeMap.tollFree, value - numberListLen);
      } else if (numberListLen > value) {
        this.removeNumber(phoneNumberTypeMap.tollFree, value);
      }
      const opType = value > oldValue ? 'increase' : 'decrease';
      this.$tracking.buyInteraction('zoom phone plan Toll-free Numbers', `TollFree Numbers - ${opType} - ${value}`);
    },
    handlePortNumberInput(value) {
      const oldValue = this.portNumberList.length;
      if (oldValue > value) {
        this.$tracking.buyInteraction(`${this.trackingPlanName} plan numbers ready for porting`, `${this.getCategoryName(this.form.category)} - decrease - ${value}`);
        this.portNumberList = this.portNumberList.slice(0, value);
        this.updateCallingPlan(this.form.localNumber, value);
        this.storagePhoneNumber();
      } else if (oldValue < value) {
        this.handlePortNumbers('increase number input');
        setTimeout(() => {
          try {
            this.$refs.portNumberInput._data.currentValue = oldValue;
          } catch (error) {
            logger.error(error);
          }
        });
      }
    },
    async handlePortNumbers(source) {
      this.$tracking.buyInteraction(`${this.trackingPlanName} numbers`, `${this.getCategoryName(this.form.category)} - ${source}`);
      const data = await this.validatePortNumberDialog.confirm({
        checkedNumberList: [...this.portNumberList],
        originPortNumberList: [...this.portNumberList],
        clearable: !this.portMinObj.count,
        localCount: this.form.localNumber,
        tollFreeCount: this.form.tollFreeNumber,
        portCount: this.portNumberList.length,
        maxSelectPhoneNumbers: maxPhoneNumber,
        maxLicenses: maxPurchaseLicense,
        handleExploreOtherPlans: this.handleExploreOtherPlans,
        isZoneProPlus: true,
      });

      this.portNumberList = data;
      this.updateCallingPlan(this.form.localNumber, data.length);
      this.storagePhoneNumber();
    },
    onRemovePortNumberList(idx) {
      this.portNumberList = this.portNumberList.filter((_, i) => idx !== i);
      this.updateCallingPlan(this.form.localNumber, this.portNumberList.length);
    },
    updatePbxBasePlanCode(code) {
      this.pbxBasePlanCode = code;
    },
    async fetchDefaultPhoneNumber() {
      const [localNumberList, tollFreeNumberList = []] = await Promise.all([
        this.searchLocalNumbers(this.getLocalNumberParamsWithIp()),
        this.searchTollFreeNumbers(this.getTollFreeNumberParamsWithIp()),
      ]);
      if (this._isDestroyed) {
        return;
      }
      this.localNumberState.phoneNumberList = localNumberList;
      this.localNumberState.cachePhoneNumberList = localNumberList;
      this.tollFreeNumberState.phoneNumberList = tollFreeNumberList;
      this.tollFreeNumberState.cachePhoneNumberList = tollFreeNumberList;

      this.storagePhoneNumber();
    },
    async initForm() {
      if (this.selectedPbxBasePlan) {
        this.pbxBasePlanCode = this.selectedPbxBasePlan.plan_code;
      }

      if (!isEmptyVal(this.selectedZoneProPlusCallingPlan)) {
        this.pbxBillingCycle = this.selectedZoneProPlusCallingPlan.billing_cycle;
        this.form.category = this.selectedZoneProPlusCallingPlan.pbxCategory;
        this.form.localNumber = Number(this.selectedZoneProPlusCallingPlan.cartInfo.selected_number) - this.portNumberList.length;
      } else if (!this.selectedPbxBasePlan.is_payg) {
        this.pbxBillingCycle = this.selectedPbxBasePlan.billing_cycle;
      } else {
        this.pbxBillingCycle = BILLING_CYCLE.ANNUAL;
      }

      if (!isEmptyVal(this.selectedTFPlan)) {
        this.form.tollFreeNumber = Number(this.selectedTFPlan.cartInfo.selected_number);
      }

      const phoneNumberCache = phoneNumberStorage.getState();

      if (isEmptyVal(phoneNumberCache)) {
        await this.fetchDefaultPhoneNumber();
        if (this._isDestroyed) {
          return;
        }
        this.selectedZoneProPlusCallingPlan && this.populateNumber(phoneNumberTypeMap.local, this.form.localNumber);
        this.selectedTFPlan && this.populateNumber(phoneNumberTypeMap.tollFree, this.form.tollFreeNumber);
      } else {
        this.localNumberState = Object.assign(this.localNumberState, phoneNumberCache.localNumberState || {});
        this.tollFreeNumberState = Object.assign(this.tollFreeNumberState, phoneNumberCache.tollFreeNumberState || {});
        this.portNumberList = phoneNumberCache.portNumberList || [];
        this.form.localNumber = Number(this.selectedZoneProPlusCallingPlan.cartInfo.selected_number) - this.portNumberList.length;
      }
    },
    removeAllPlans () {
      this.removePlanByKey(planTypes.zoneproplus)
      const zoomPhonePlans = computedPbxPlans(this.getSelectedPlans)
      this.batchRemovePlan(zoomPhonePlans)
    },
    addLargeMeetingCard() {
      this.attendeeInfoTooltip = false
      this.$core.addon(planTypes[planTypes.LARGE_MEETING])
    }
  },
  created() {
    this.initForm().then(() => this.numberListLoading = false);
    this.selectPhoneNumberDialog = new ServiceConfirm(SelectPhoneNumberDialog);
    this.validatePortNumberDialog = new ServiceConfirm(ValidatePortNumberDialog);
  },
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
@import '@/styles/scss-utils.scss';

.opc-zone-bundle {
  &__main {
    .main-color-icon {
      font-size: 14px;
      color: $theme-color;
    }

    .opc-zone-cycle.opc-cycle {
      margin-top: 24px;
    }

    .form-row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;

      @include media(mobile, tablet) {
        &.form-row-1 {
          flex-direction: column;
          align-items: flex-start;
        }
      }

      .edit-numbers {
        &.zm-button.zm-button--link {
          padding: 0px;
        }

        font-weight: 600 !important;
      }
    }

    .label-title-1 {
      font-size: 18px;
      font-weight: 700;
      line-height: 27px;
      letter-spacing: 0em;
      text-align: left;
    }

    .label-title-2 {
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: 0em;
      text-align: left;
    }

    .label-title-sub {
      font-size: 12px;
      font-weight: 450;
      line-height: 14px;
      letter-spacing: 0em;
      text-align: left;
    }

    .label-desc-1 {
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      letter-spacing: 0em;
      text-align: left;
    }

    .zm-tag-group {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
    }

    .zm-tag--middle.number-tag {
      padding: 8px 10px;
      margin-right: 8px;
      margin-bottom: 8px;

      .zm-tag__label {
        padding: 0;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 120%;
        color: #00053d;
        @include darkTextColor;
      }

      .zm-tag__close.zm-button {
        transform: scale(1.5);

        &:hover {
          background-color: transparent !important;
        }
      }
    }

    .opc-pbx-number-item {
      &__combine {
        display: flex;
        @include media(mobile, tablet) {
          display: block;
        }
        margin-bottom: 12px;

        .opc-pbx-number-item__title-wrap {
          padding-right: 10px;
        }
      }

      &__split {
        .opc-pbx-number-item__max-limit {
          &.zm-alert--warning {
            margin-bottom: 12px;
          }
        }
      }

      &__tf,
      &__port {
        padding-top: 12px;
      }

      @include media(mobile, tablet) {
        &__port {
          padding-bottom: 10px;
          border-bottom: 1px solid #dfe3e8;
        }
      }

      &__title-wrap {
        flex: 1;
      }

      &__max-limit {
        &.zm-alert--warning {
          margin-right: 10px;
          align-items: center;
          padding: 8px 12px;
          background: #fef7d9;
          margin-top: 4px;

          .zm-button {
            display: block;
            padding: 0px;
            font-size: 14px;
            font-weight: 600;
            line-height: 16.8px;
            text-align: left;
          }

          .opc-pbx-number-tips-info {
            padding-left: 8px;

            &__content {
              font-family: Almaden Sans;
              font-size: 14px;
              font-weight: 500;
              line-height: 21px;
              text-align: left;
              margin-left: 6px;
            }
          }
        }
      }

      &.opc-pbx-number-alert-wrap,
      &__max-limit {
        margin-bottom: 12px;

        .opc-pbx-number-tips-info {
          display: flex;
          align-items: center;
          .zm-icon-info-outline {
            margin-right: 8px;
            font-size: 18px;
          }
        }

        .billing-icon-warning {
          width: 16px;
          height: 16px;
          position: relative;
          margin-right: 8px;
          &::before {
            content: '';
            background-image: url('../../../assets/Alert.svg');
            width: 16px;
            height: 16px;
            background-repeat: no-repeat;
            background-size: cover;
            position: absolute;
            top: 0;
            left: 0;
          }
        }
      }

      &__tip-lm-btn {
        display: block;
      }
    }
    .operation-loading {
      height: 24px;
      width: 100%;
    }

    .opc-zone-bundle__expand-lm-promo {
      color: #515079;
      @include darkTheme() {
        color: $dark-text-color2;
      }
    }
  }
}
</style>
